<template>
<div>
    <hp5-semantic size-selection="xs">
        <div v-if="clinic.taglines">
            <p v-for="(tagline, index) in clinic.taglines" :key="index">{{ tagline }}</p>
        </div>
    </hp5-semantic>
    <hp5-spacing-vertical xs="sm"></hp5-spacing-vertical>
</div>
</template>

<script setup>

    const props = defineProps({
        clinic: Object
    })

</script>